import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ContactRequest {
  categoryId: number;
  name: string;
  phone: string;
  email: string;
  budget?: string;
  travelDay?: string;
  departurePlace?: string;
  departureDate?: string;
  content: string;
  recaptcha: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private readonly MAX_CONTENT_LENGTH = 300;
  private readonly MIN_CONTENT_LENGTH = 3;
  private readonly EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  private readonly PHONE_PATTERN = /^[0-9+-]{8,15}$/;

  constructor(private http: HttpClient) { }

  getContactCategories() {
    return this.http.get('/api/site/contactCategories');
  }

  createContact(data: ContactRequest) {
    // 基本資料驗證
    if (!this.validateContactData(data)) {
      return throwError('資料驗證失敗');
    }

    // 清理和準備數據
    const sanitizedData = this.sanitizeContactData(data);

    return this.http.post<any>('/api/site/contact', sanitizedData).pipe(
      map(response => response),
      catchError(error => {
        console.error('聯絡表單提交錯誤:', error);
        return throwError('提交失敗，請稍後再試');
      })
    );
  }

  private validateContactData(data: ContactRequest): boolean {
    // 必填欄位檢查
    if (!data.categoryId || !data.name || !data.phone || !data.email || !data.content || !data.recaptcha) {
      return false;
    }

    // 內容長度檢查
    if (data.content.length < this.MIN_CONTENT_LENGTH || data.content.length > this.MAX_CONTENT_LENGTH) {
      return false;
    }

    // Email 格式檢查
    if (!this.EMAIL_PATTERN.test(data.email)) {
      return false;
    }

    // 電話格式檢查
    if (!this.PHONE_PATTERN.test(data.phone)) {
      return false;
    }

    return true;
  }

  private sanitizeContactData(data: ContactRequest): any {
    // 移除可能的 HTML 標籤
    const sanitized = {
      ...data,
      name: this.sanitizeString(data.name),
      email: this.sanitizeString(data.email),
      phone: this.sanitizeString(data.phone),
      content: this.sanitizeString(data.content)
    };

    // 移除不必要的欄位
    delete sanitized['website'];
    delete sanitized['submitTime'];

    return sanitized;
  }

  private sanitizeString(str: string): string {
    return str
      .trim()
      .replace(/<[^>]*>/g, '') // 移除 HTML 標籤
      .replace(/[<>]/g, '') // 移除 < 和 >
      .replace(/javascript:/gi, '') // 移除 javascript:
      .replace(/on\w+=/gi, ''); // 移除 onclick= 等事件
  }
}
